import {useEffect} from 'react';
import {useSidebarToggleShortcut} from '../../hooks/useSidebarToggleShortcut';
import {logger} from '../../utils/logger';

/**
 * Component that sets up global keyboard shortcuts for the sidebars
 * This is a headless component that just initializes the keyboard shortcuts
 */
export function SidebarShortcutHandler() {
  // This hook sets up the keyboard shortcuts for sidebar toggling
  // Using useSidebarToggleShortcut instead of useLocalSidebarToggle
  // for direct context access instead of custom events
  useSidebarToggleShortcut();

  // Log when the component mounts
  useEffect(() => {
    logger.component('SidebarShortcutHandler: Component mounted');
  }, []);

  // This is a "headless" component that doesn't render anything
  return null;
}
